export class AppointmentStatus
{
    statusCode: number;
    statusDescription:string;

    public static STATUS_SCHEDULED:number = 1;
    public static STATUS_COMPLETE: number = 2;
    public static STATUS_CANCELLED: number = 3;
    public static STATUS_FIRST_AVAILABLE: number = 4;
}